var map = {
	"./1_tools.png": "346f",
	"./boosts.png": "6383",
	"./buildings.png": "935b",
	"./companies.png": "0f07",
	"./contribs.png": "f0bb",
	"./dice-1.png": "063b",
	"./dice-2.png": "0abe",
	"./dice-3.png": "b981",
	"./dice-4.png": "c40e",
	"./dice-5.png": "2fd2",
	"./dice-6.png": "9060",
	"./energies.png": "3ee3",
	"./giveaway.png": "e5cd",
	"./jail.png": "ef01",
	"./lands.png": "1ff8",
	"./logo-qtt.png": "8855",
	"./logo.png": "cf05",
	"./neverlucky.png": "f8d8",
	"./quizz.png": "ac43",
	"./start.png": "fd98",
	"./switch.png": "be54",
	"./temples.png": "f13f",
	"./tools.png": "f841",
	"./wheel.png": "40e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";